<div class="row py-5 " style="background: black;">
    <div class="col-sm-12 w-100 py-5">
        <div class="d-flex flex-column justify-content-between  py-5 row w-100 m-0">

  
 
                                               <!-- <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="https://appointele.com/assets/logo2020w.png" />-->

                                                    <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />

<div class="w-100 text-center my-5">
    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate >Do you have an appointment? </h3>
</div>




<div class="col-sm-12 d-flex justify-content-around w-100 px-0 my-5" >

<div class="col-sm-5 my-2" >
    <div class="row w-100  bg-white text-center " (click)="yesAppointmentQuestionaire()">
    <h1 class=" text-center text-dark p-3   w-100" style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark " translate>YES</a></h1>
</div>
</div>
<div class="col-sm-5 my-2 text-center"   >
    <div class="row w-100 pl-1 bg-white text-center" (click)="noAppointmentQuestionaire()" >
    <h1 class="text-dark  w-100 p-3 text-center " style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark " translate >NO</a></h1>
</div>
</div>


</div>
    </div>
</div>
</div>
